<template>
    <div class="vip-card">
        <a-row>
            <a-col :span="13" >用户票券id：{{ticketData.userTicketNo}}</a-col>
            <a-col :span="11">下单人用户票券id：<span class="text-primary">{{ticketData.originalUserTicketNo}}</span></a-col>
        </a-row>
        <a-row>
            <a-col :span="13">交易订单号：<a @click="toDetailTicket(1)" :class="ticketData.tradeNo?'text-primary':'text-disabled'">{{ticketData.tradeNo || "--"}}</a></a-col>
            <a-col :span="11" v-if="ticketData.mainUserTicketNo">关联主票：<a @click="toDetailTicket(2)" class="text-primary">{{ticketData.mainUserTicketNo}}</a></a-col>
            <a-col :span="11" v-else>关联主票：--</a-col>
        </a-row>
        <a-row>
            <a-col :span="13">会员手机号：{{ticketData.phone}}</a-col>
            <a-col :span="11">票券内部标识：{{ticketData.name}}</a-col>
        </a-row>
        <a-row>
            <a-col :span="13">票券展示名称：{{ticketData.showName}}</a-col>
            <a-col :span="11">票券类型：{{['','期限卡','次卡','套餐票','线下票','课程'][ticketData.type]}}</a-col>
        </a-row>
        <a-row>
            <a-col :span="13">票券状态：{{$utils.ticketState[ticketData.showState]}}{{ticketData.invalidType > 0 ? '(' + $utils.uselessState[ticketData.invalidType] + ")" : ''}}</a-col>
            <a-col :span="11">禁用状态：{{['未禁用','已禁用'][Number(ticketData.isForbidden)]}}</a-col>
        </a-row>
        <a-row>
            <a-col :span="13">冻结状态：{{['未冻结','已冻结'][Number(ticketData.isFrozen)]}}</a-col>
            <a-col :span="11">
                使用有效期：<span>{{ticketData.validStartTime || "--"}} ~ {{ticketData.validEndTime || "--"}}</span>
                <span v-if="Boolean(ticketData.delayTime)" class="text-fail">（续期截止日：{{$moment(ticketData.delayTime).format('YYYY-MM-DD')}}）</span>
            </a-col>
        </a-row>
        <a-row>
            <a-col :span="13">会员名称：{{ticketData.userName}}</a-col>
            <a-col :span="11">票券总次数：<span class="text-fail">{{ticketData.totalNum === -1 ? '不限' : ticketData.totalNum}}次</span></a-col>
        </a-row>
        <a-row>
            <a-col :span="13">原持有人总有效核销次数：{{ticketData.originalVerifyNum}} 次</a-col>
            <a-col :span="11">剩余可使用次数（不包含预约）：<span class="text-fail">{{ticketData.totalNum === -1 ? '不限' : (ticketData.totalNum - ticketData.usedNum)}}次</span></a-col>
        </a-row>
        <a-row>
            <a-col :span="13">购买途径：<span>{{(ticketData.platform == "收银台" ? ticketData.grantShopName : ticketData.platform) || '--'}}</span></a-col>
            <a-col :span="11">票券售价：<span class="text-fail">{{ticketData.sellShowPrice | myToFixed2}} 元</span></a-col>
        </a-row>
        <a-row>
            <a-col :span="13">收银台优惠使用：<span>{{ticketData.useCounterDiscount || '--'}}</span></a-col>
            <a-col :span="11">订单实际支付金额：<span class="text-fail">{{ticketData.tradePayAmount | myToFixed2}} 元</span></a-col>
        </a-row>
        <a-row>
            <a-col :span="13">优惠券使用：<span>{{ticketData.useCoupon || '--'}}</span></a-col>
            <a-col :span="11" v-if="ticketData.hasOwnProperty('price')">票券实际支付金额：<span class="text-fail">{{ticketData.price | myToFixed2}} 元</span></a-col>
            <a-col :span="11" v-else>票券实际支付金额：<span class="text-fail">{{ticketData.ticketPayAmount | myToFixed2}} 元</span></a-col>
        </a-row>
        <a-row>
            <a-col :span="13">订单实际支付积分：<span class="text-fail">{{$utils.thousandSplit(ticketData.tradePayPoint) | isEmptyUnit("积分")}} </span></a-col>
            <a-col :span="11">票券实际支付积分：<span class="text-fail">{{$utils.thousandSplit(ticketData.ticketPayPoint) | isEmptyUnit("积分")}} </span></a-col>
        </a-row>
        <a-row>
            <a-col :span="13">票券售卖积分：<span class="text-fail">{{$utils.thousandSplit(ticketData.ticketSellPoint) | isEmptyUnit("积分")}}</span></a-col>
        </a-row>
    </div>
</template>

<script>

    /**
     * 基础卡的组件
     * @prop {Object} ticketData 基础卡对象
     * @prop {Boolean} showOwner 是否展示票券卡的持有者信息
     *
     */
    export default {
        name: "member-card",
        zh: "基础卡组件",
        data() {
            return {
            };
        },
        props: {
            ticketData: {type: Object,default: {amount: 0}},
            showOwner: {type: Boolean,default: false},
        },
        methods: {
            toDetailTicket(id) {
                if (id == 1) {
                    if (!this.ticketData.tradeNo) return;
                    this.$router.push({ name: "buyOrder", params: {orderId: this.ticketData.tradeNo}});
                } else if (id == 2) {
                    if (!this.ticketData.mainUserTicketNo) return;
                    this.$router.push({ name: "amendTicketUser", query: {id: this.ticketData.mainUserTicketNo}});
                }
                // 跳转至详情页
            },
        },
        beforeCreate() {},
        created() {},
        updated() {},
        mounted() {},
        computed: {},
        watch: {
            'ticketData'(val) {
                this.ticketData = val;
            }
        }
    };
</script>

<style lang="scss">
    .vip-card {
        margin-bottom: 16px;
        padding: 16px;
        background:rgba(250,250,250,1);
        border-radius: 4px;
        border: 1px solid rgba(233,233,233,1);
        overflow: auto;

        .ant-row {
            height: 30px;
            line-height: 38px;
        }
        .text-fail {
            font-size: 16px;
            font-weight: 600;
        }
    }
</style>
